import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const UserActions = importer('Stores/Users/Actions')
export default function * success ({ res }) {
  try {
    const { token_type, id_token } = res
    const data = token_type + ' ' + id_token
    yield put(UserActions.loginHeroku(data))
  } catch (error) {
    // console.log(error)
  }
}
